import { AGENT_URL } from '@/config/env'
import { fetchJsonWithAuth } from '@/lib/api'

import type { DashboardBoard } from './types'

/**
 * Fetch the whole-page Active Lines snapshot: pool totals, per-line grid/map
 * detail, the usage ribbon's per-duty split, and the backlog table.
 *
 * hoku relays helpcare's `/phone-lines/allocation-board` verbatim, so the response
 * is `DashboardBoard` as-is — no adapter. Super-user only; the endpoint 403s
 * otherwise (see the gate in `useAllocationBoardQuery`).
 */
export async function fetchAllocationBoard(
  token: string
): Promise<DashboardBoard> {
  return fetchJsonWithAuth<DashboardBoard>({
    token,
    url: `${AGENT_URL}/phone-lines/allocation-board`,
    errorMessage: 'Failed to fetch allocation board',
  })
}
